import React from 'react';

import {bindActionCreators} from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../redux/actions';

import '../styles/lookup.scss';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TablePagination from '@mui/material/TablePagination';

import ScienceIcon from '@mui/icons-material/Science';
import WastewaterPricing from './WastewaterPricing';
import InfoCard from './InfoCard';
import LookupHero from './LookupHero';

class VendorInfo extends React.Component {
  state = {
    page: 0,
    rowsPerPage: 10,
    productSearch: '',
  };

  filterProducts() {
    if (!this.props.info?.products) return [];
    const query = this.state.productSearch.toLowerCase();
    return this.props.info.products.filter(product =>
      product.model.toLowerCase().includes(query) ||
      product.description.toLowerCase().includes(query)
    );
  }

  productsSummary() {
    const products = this.props.info?.products || [];
    if (!products.length) return 'No products listed';
    const preview = products.slice(0, 2).map((p) => p.model).join(', ');
    return products.length > 2 ? `${preview} +${products.length - 2} more` : preview;
  }

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: parseInt(event.target.value, 10), page: 0 });
  };

  render() {
    if (this.props.info?.type !== 'vendor') return null;

    const products = this.props.info.products || [];
    const filtered = this.filterProducts();
    const pricingCount = this.props.info.wastewater_prices?.length || 0;

    return (
      <div className="info-container">
        <LookupHero
          title={this.props.info.name}
          subtitle="Vendor"
          meta={(
            <>
              <span><b>{products.length}</b> product{products.length === 1 ? '' : 's'}</span>
              {pricingCount > 0 && (
                <span><b>{pricingCount}</b> pricing record{pricingCount === 1 ? '' : 's'}</span>
              )}
            </>
          )}
        />

        <InfoCard
          id="products-list"
          icon={<ScienceIcon />}
          title="Products"
          count={products.length}
          subtitle={`From ${this.props.info.name}`}
          summary={this.productsSummary()}
        >
          <input
            type="text"
            placeholder={`Filter products from ${this.props.info.name}`}
            value={this.state.productSearch}
            onChange={(e) => this.setState({ productSearch: e.target.value, page: 0 })}
            className="search-input"
          />

          <TableContainer component={Paper} className="product-table-container">
            <Table className="product-table" aria-label="vendor products" size="medium">
              <TableBody>
                {filtered
                  .slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage)
                  .map((product) => (
                    <TableRow
                      key={`product-${product.id}`}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell align="left" className="product-model-cell" size="medium">
                        <b>{product.model}</b>
                      </TableCell>
                      <TableCell align="left" className="product-description-cell" title={product.description}>
                        <span className="product-description-text">{product.description}</span>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filtered.length}
            rowsPerPage={this.state.rowsPerPage}
            page={this.state.page}
            onPageChange={this.handleChangePage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
          />
        </InfoCard>

        <WastewaterPricing contextType="v" />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    authToken: state.authToken,
    info: state.info,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(VendorInfo);
